import React from 'react';
import { ArrowButton, AsyncDataPlaceholder } from '../../../../../ui';
import { ActionsRow } from './layout/ActionsRow';
import { useGuestBookingFormContext } from './hooks/useGuestBookingFormContext';
import { useHasRequiredFields } from './hooks/useHasRequiredFields';

interface IGuestBookingFormActionsProps {
	submitButtonText: string;
}

export const GuestBookingFormActions = ({
	submitButtonText,
}: IGuestBookingFormActionsProps) => {
	const { formState } = useGuestBookingFormContext();
	const hasRequiredFields = useHasRequiredFields();

	return (
		<>
			<ActionsRow>
				<ArrowButton
					type="submit"
					disabled={!hasRequiredFields || formState.isSubmitting}
				>
					{submitButtonText}
				</ArrowButton>
			</ActionsRow>
			{formState.isSubmitting && <AsyncDataPlaceholder />}
		</>
	);
};
